import { IPalette, ISemanticColors } from "@fluentui/react/lib/Styling"

export const DefaultPalette = {
    themePrimary: "#0077c8",
    themeLighterAlt: "#E5F1F9",
    themeLighter: "#D9EBF7",
    themeLight: "#B7D9EF",
    themeTertiary: "#59a8dd",
    themeSecondary: "#1985ce",
    themeDarkAlt: "#006bb3",
    themeDark: "#005fa0",
    themeDarker: "#00436f",
    neutralLighterAlt: "#faf9f8",
    neutralLighter: "#f3f2f1",
    neutralLight: "#E4E4E4",
    neutralQuaternaryAlt: "#e1dfdd",
    neutralQuaternary: "#d0d0d0",
    neutralTertiaryAlt: "#c8c6c4",
    neutralTertiary: "#CCCCCC",
    neutralSecondary: "#999999",
    neutralPrimaryAlt: "#4b4b4b",
    neutralPrimary: "#333333",
    neutralDark: "#272727",
    black: "#1d1d1d",
    white: "#ffffff"
} as Partial<IPalette>

export const DarkPalette = {
    themePrimary: "#0077c8",
    themeLighterAlt: "#00436f",
    themeLighter: "#004877",
    themeLight: "#0069af",
    themeTertiary: "#004877",
    themeSecondary: "#0069af",
    themeDarkAlt: "#1483cd",
    themeDark: "#3394d4",
    themeDarker: "#62aee0",
    neutralLighterAlt: "#3c3c3c",
    neutralLighter: "#444444",
    neutralLight: "#515151",
    neutralQuaternaryAlt: "#595959",
    neutralQuaternary: "#5f5f5f",
    neutralTertiaryAlt: "#7a7a7a",
    neutralTertiary: "#c8c8c8",
    neutralSecondary: "#d0d0d0",
    neutralPrimaryAlt: "#333333",
    neutralPrimary: "#ffffff",
    neutralDark: "#f4f4f4",
    black: "#f8f8f8",
    white: "#333333"
} as Partial<IPalette>

export function defaultSemanticColors(palette: Partial<IPalette>) {
    return {
        errorIcon: "#DD6364",
        errorText: "#DD6364",
        errorBackground: "#DD636426",
        warningIcon: "#F5CB6E",
        warningBackground: "#F5CB6E40",

        focusBorder: palette.themePrimary,
        disabledText: palette.neutralSecondary,

        buttonBackground: palette.themeLighter,
        buttonBackgroundPressed: palette.themeLighter,
        buttonBackgroundHovered: palette.themeLight,
        primaryButtonBackground: palette.themePrimary,
        primaryButtonBackgroundHovered: palette.themeDark,
        menuItemBackgroundHovered: palette.themeLight,

        disabledBackground: "#EFEFEF",
        buttonBackgroundDisabled: palette.neutralLight
    } as ISemanticColors
}
